import React from "react"
import Input from "../Elements/Form/Input"

interface RevisionHeaderProps {
  searchText: string
  onChangeSearchText: (searchText: string) => void

  cancelRevision: () => void
  isDisabledCancelRevisionButton: boolean
  finishRevision: () => void
  isDisabledFinishRevisionButton: boolean
}

export default function RevisionHeader({
  searchText,
  onChangeSearchText,

  cancelRevision,
  isDisabledCancelRevisionButton,
  finishRevision,
  isDisabledFinishRevisionButton,
}: RevisionHeaderProps) {
  return (
    <div className="mx-auto flex max-w-7xl flex-1 flex-col justify-center px-8 py-8">
      <div className="mb-2 items-baseline sm:flex sm:items-center print:hidden">
        <span className="flex-auto">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="searchText"
          >
            Штрихкод товара
          </label>

          <span className="z-0 rounded-md shadow-sm sm:relative">
            <Input
              type="text"
              name="searchText"
              value={searchText}
              onChange={(e) => onChangeSearchText(e.target.value)}
            />
          </span>
        </span>

        <span className="mt-4 sm:ml-3">
          <button
            type="button"
            className="rounded-md border border-gray-300 bg-white px-3.5 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-200 disabled:text-gray-400 disabled:shadow-none"
            onClick={() => cancelRevision()}
            disabled={isDisabledCancelRevisionButton}
          >
            Отменить ревизию
          </button>
        </span>

        <span className="mt-4 sm:ml-3">
          <button
            type="button"
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-blue-100 disabled:text-gray-400 disabled:shadow-none"
            onClick={() => finishRevision()}
            disabled={isDisabledFinishRevisionButton}
          >
            Завершить ревизию
          </button>
        </span>
      </div>
    </div>
  )
}
